import React from 'react'
import clsx from 'clsx'
import { CircularProgress } from '@mui/material'

import useStyles, { StyledButton } from './styles'

const Button = ({ className, invert = null, loading, children, ...props }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <StyledButton fullWidth invert={invert ? 'true' : null} {...props}>
        <div className={classes.children}>
          {children}

          {loading && (
            <CircularProgress
              color='secondary'
              size='0.75rem'
              className={classes.loading}
            />
          )}
        </div>
      </StyledButton>
    </div>
  )
}

export default Button
